import { LocalStorageService } from 'br2s-ui-common-utils-02';
import { Code, ResultItem } from './AccountSettings';
import { AxiosResponse } from 'axios';
import { ACCOUNT_SETTINGS } from '@/utilities/constants';

export const getContactApiType = () => {
  const { cspIndicator, gcIndicator } = LocalStorageService.getAuthInfo(
    'cspIndicator',
    'gcIndicator',
  );

  if (cspIndicator === 'Y' && gcIndicator === 'N') return 'RQI';
  if (cspIndicator === 'N' && gcIndicator === 'Y') return 'GC';

  return 'POSITION_HOLDER';
};

export const retrieveContactInfoFromResponse = (
  response: AxiosResponse,
  apiType: string,
) => {
  const { user } = LocalStorageService.getAuthInfo('user');
  const { profileId } = user ?? { profileId: '' };

  if (apiType === 'RQI') {
    return response.data?.result?.qiProfiles?.[0];
  }

  if (apiType === 'GC') {
    return response.data?.result;
  }

  return response.data?.result?.positionHolders?.find(
    ({ officerCategory, profileId: officerProfileId }: ResultItem) =>
      officerCategory === 'IND' && profileId === officerProfileId,
  );
};

export const getUpdateDetailsLink = () => {
  const { cspIndicator } =
    LocalStorageService.getAuthInfo('cspIndicator') ?? 'N';

  const link =
    ACCOUNT_SETTINGS.ALERT[cspIndicator === 'Y' ? 'cspYLink' : 'cspNLink'];
  const label =
    ACCOUNT_SETTINGS.ALERT[cspIndicator === 'Y' ? 'cspYLabel' : 'cspNLabel'];

  return { link, label };
};

export const extractCodeValue = (codeList: Code[], value: string) => {
  if (!codeList) return value;

  return codeList.find((code) => code.value === value)?.description ?? value;
};
